<div
  class="slide-bucket-card"
  [class.has-background]="card.mediaBackground?.id"
  [class.has-background-color]="card.backgroundColor"
  [class.has-error]="showErrors && !card.mediaBackground && !card.text"
  [cardBackground]="{ backgroundColor: card.backgroundColor }">

  @if (card.mediaBackground) {
    <img
      class="bucket-image"
      [dynamicWidth]="false"
      [imageWidth]="800"
      [shouldCreateOverlay]="false"
      [cardBackground]="{ mediaBackground: card.mediaBackground }">
  }

  <div class="card-content">
    @if (card.text) {
      <ng-scrollbar thumbClass="custom-scrollbars">
        <div class="buckets-and-card-wrapper__content ck-text" [autoTextDirection]="isTranslation" [autoTextDirectionValue]="card.text" [rtl]="slide?.langcode" [padding]="spacing" [innerHtml]="card.text | safeHtml"></div>
      </ng-scrollbar>
    }
  </div>

  @if (showEditButton) {
    <div class="card-actions">
      <button
        mat-icon-button
        class="button button--icon button--icon-extra-small button--black"
        (click)="emitEdit($event)">
        <lib-icon icon="pencil-simple"></lib-icon>
      </button>
      <button
        mat-icon-button
        class="button button--icon button--icon-extra-small button--black"
        (click)="emitRemove($event)">
        <lib-icon icon="trash"></lib-icon>
      </button>
    </div>
  }
</div>